/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { Linking, Platform } from 'react-native';

const openInAppBrowser = async (url: string) => {
  if (!url) {
    return;
  }
  if (Platform.OS === 'web') {
    // Open the link in a new tab for web platform
    window.open(url, '_blank');
  } else {
    const module = await import('react-native-inappbrowser-reborn');
    const InAppBrowser = module.default;

    const isAvailable = await InAppBrowser.isAvailable();
    if (isAvailable) {
      setTimeout(async () => {
        await InAppBrowser.open(url, {
          // iOS Properties
          dismissButtonStyle: 'close',
          animated: true,
          // Android Properties
          showTitle: true,
          enableUrlBarHiding: true,
          enableDefaultShare: true,
          forceCloseOnRedirection: true,
        });
      }, 500);
    } else {
      Linking.openURL(url);
    }
  }
};

export default openInAppBrowser;
